<template>
  <div
    v-if="((searchKey && $t(title.replace('-', '')).indexOf(searchKey) > -1) || !searchKey)"
    :class="{
      'first-level-menu': level === 1,
      'other-level-menu': level !== 1,
    }"
  >
    <i v-if="icon" :class="`${'sidebar-icon' + ' '}${icon} ${!showSidebar ? 'hide-sidebar': ''}`" />
    <span v-if="title" class="title-in-menu" :class="{'common-title': common}" v-html="highlightedTitle" />
    <el-tooltip
      v-if="showSidebar && !hasChild"
      class="item-tooltip"
      effect="dark"
      :content="isFavourite ? $t('Aside.Item.962789-0') : $t('Aside.Item.962789-1')"
      placement="top"
    >
      <i
        :class="{
          'is-favourite': isFavourite
        }"
        class="action-icon el-icon-star-on"
        @click.stop="toggleFavourite"
      />
    </el-tooltip>
  </div>
</template>

<script>
import { SappModule } from '@/store/modules/app'

export default {
  name: 'MenuItem',
  inject: ['features'],
  props: {
    hasChild: {
      type: Boolean,
      default: false
    },
    common: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => ({ chilren: [] })
    },
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    searchKey: {
      type: String,
      default: ''
    },
    level: {
      type: Number,
      default: 1
    }
  },

  computed: {
    highlightedTitle() {
      if (this.common) {
        return `${this.$t(this.title.replace('-', ''))}<span class="common-num"><span class="common-selected-num">${this.favourites.length}</span>/5</span>`
      }
      if (!this.title || !this.searchKey) {
        return this.$t(this.title.replace('-', ''))
      }

      const regex = new RegExp(`(${this.searchKey})`, 'gi')
      const highlighted = this.$t(this.title.replace('-', '')).replace(regex, '<div class="highlight">\$1</div>')
      console.log('highlighted', highlighted)
      return highlighted
    },
    showSidebar() {
      return SappModule.sidebar.opened
    },
    isLeaf() {
      console.log('this.item', this.item)
      return this.item && this.item.children && this.item.children.length === 0
    },
    isCollapse() {
      return !SappModule.sidebar.opened
    },
    favourites() {
      return SappModule.favouriteMenu
    },
    isFavourite() {
      return this.favourites.find((fav) => fav.id === this.item.id)
    }
  },

  methods: {
    toggleFavourite() {
      SappModule.toggleFavourite(this.item)
    }
  }
}
</script>
<style lang="scss">
.el-menu-item{
  .other-level-menu{
    padding: 11px 0;
    .title-in-menu{
      width: calc(100% - 20px) !important;
      display: -webkit-box !important;
      -webkit-box-orient: vertical !important;
      -webkit-line-clamp: 2 !important; /* 最多显示2行 */
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      white-space: break-spaces !important;
      line-height: 18px;
    }
  }
}
.common-title{
  display: inline-block;
  width: calc(100% - 52px) !important;
}
.common-num{
  float: right;
  color: #BABEC7 !important;
  font-size: 12px;
  line-height: 40px;
  .common-selected-num{
    float: left;
    font-size: 14px;
    color: #525765 !important;
  }
}
.el-menu-item{
  color: #525765;
}
.highlight{
  color: #3C6EF0;
  display: inline-block;
  vertical-align:top;
}
</style>
<style lang="scss" scoped>

.sidebar-icon {
  font-size: 18px;
  margin-right: 8px;
}
.action-icon {
  opacity: 0;
  transition: opacity 0.15s ease-in-out;
  position: absolute;
  top: 11px;
  right: 8px;
  font-size: 18px;
  color: rgba(210, 210, 210, 1) !important;
  &.is-favourite {
    color: rgba(254, 203, 82, 1) !important;
    opacity: 1;
    &:hover {
      color: rgba(254, 164, 82, 1) !important;
    }
  }
}
</style>
